import Rails from "@rails/ujs";

export const ProductsIndexView = {

  init: function() {
    // bootstrap select automagicly adds glyphicon class to option with data-icon
    // we do not want it
    let searchHack = $('.glyphicon.fa.fa-search');
    if (searchHack) {
      searchHack.removeClass("glyphicon");
    }
    $( "#product" ).change(function() {
      let selectedIndex = this.selectedIndex;
      if(selectedIndex!=0) self.location=this.options[selectedIndex].value
    });
		$( "#product_list_little" ).change(function() {
			let selectedIndex = this.selectedIndex;
			if(selectedIndex!=0) self.location=this.options[selectedIndex].value
		});
    $(document).on('ajax:success', function (event, xhr, settings) {
      let json = event.detail[0];
      switch(json.id) {
        case 'product_added':
          //update totoal price
          $('.js-carts-total-price').html(json.carts_total_price);
          // show message
          let addingSuccess = $('.product[data-product-id="' + json.product_id + '"]')
            .find('.adding-success');
          addingSuccess.fadeIn("fast");
          break;
      }
    });

    $(document).on('ajaxError', function (event, xhr, settings) {
      try {
        let json = $.parseJSON(xhr.responseText);
        switch (json.id) {
          case 'product_not_added':
            let addingNoSuccess = $('.product[data-product-id="' + json.product_id + '"]').find('.adding-no-sucess');
            addingNoSuccess.fadeIn();
            setTimeout(function(){
              addingNoSuccess.fadeOut();
            }, 3000);
            break;
        }
      }
      catch(e) {
        // not JSON
      }
    });

    $('.test-btn').on('click', function() {
      let product = $(this).parents('.product');
      product.find('form.button_to').submit();
    });

    $('form.new_product').each(function (key, form) {
      $('.quantity-to-add').validate({
        rules: {
          'quantity': {
            required: true,
            number: true
          }
        }
      })
    });

    // Watchdog init
    ProductsIndexView.initWatchDog();
    ProductsIndexView.validation();
		ProductsIndexView.initAmountButtons();
		ProductsIndexView.initProductFilter();

		// Headline Catcher init
		ProductsIndexView.headlineCatcher();
  },

  initWatchDog: function() {
    let watchdog_modal = $('#watchdog-modal');
    let watchdog_btn = $('.watchdog-btn');
    let submit_btn = watchdog_modal.find('.btn-success');

    //watchdog_btn.;
    watchdog_btn.off('click.watchdog').on('click.watchdog', function() {
      let btn = $(this);
      let window = $('#watchdog-modal');

      window.find('input#watchdog_product_id').val(btn.attr('data-product-id'));
      window.modal();
    });

    //watchdog_btn.off('click.watchdog');
    submit_btn.off('click.watchdog').on('click.watchdog', function() {
      let form = document.getElementById('watchdog-form');
      Rails.fire(form, 'submit');
    });
  },

  validation: function() {
    $(document).ready(function(){
      $("#watchdog-form").validate({
        rules: {
          'watchdog[email]': {
            required: true,
            email: true
          }
        }
      });
    });
  },

	initAmountButtons: function() {

		$('.js-btn-minuse').on('click', function () {
      let val = parseInt($(this).parent().siblings('input').val());
      if ((val) <= 1) {
        return false;
      }

			let	increment = parseInt($(this).attr('data-increment'));
			let input = $(this).parent().siblings('input');
			input.val(val - increment);
		});

		$('.js-btn-pluss').on('click', function () {
      let val = parseInt($(this).parent().siblings('input').val());
			let	increment = parseInt($(this).attr('data-increment'));
			$(this).parent().siblings('input').val(val + increment);
		});
	},

	initProductFilter: function () {

	},

	headlineCatcher: function () {
		// only show and hide logic, highlighting active is in Sidebar.scrollCheck()

		let headline_catcher = $('#js-headline-catcher');

		let catcher_left = headline_catcher.offset().left;
		let catcher_width = headline_catcher.width();

		headline_catcher.css("position", "fixed");
		headline_catcher.css("left", catcher_left);
		headline_catcher.css("width", catcher_width);

	}
};

export const ProductsShowView = {

  init: function() {
    // same stuff
    ProductsIndexView.init()
  }
};
